export default __webpack_public_path__ + "static/media/woman-beard.68ec83fa.png";